
import waitAll from './utils/src/waitAll'
import WildEmitter from './utils/src/WildEmitter'

let global = window || {};

function ZJApp() {
    WildEmitter.call(this);
}
WildEmitter.mixin(ZJApp);

global.ZJApp = global.ZJApp || new ZJApp();

waitAll([

    // 加载 element-ui 样式
    ()=>import(/* webpackChunkName: 'theme-default-element-ui' */ './theme-default/element.scss'),

    // 加载 app 样式
    ()=>import(/* webpackChunkName: 'theme-default-app' */ './theme-default/index.scss'),

    // 加载样式定义文件
    ()=>import(/* webpackChunkName: 'theme' */ './theme-default/index'),

    ()=>import(/* webpackChunkName: 'client' */ './index'),
])
.then(r=>{
    let bootstrap = r[3].default.bootstrap;
    let config = {};
    let theme = r[2].default;
    bootstrap({
        el: '#app',
        config,
        theme,
    });
});


